import { BRAND } from '../../../constants'
import { Menu } from '../../../models/interfaces/MegaMenu.interface'

type SectionTitleProps = {
  title: string
  handleClick: () => void
  activeMegaMenu: Menu | null
  isHomepage: boolean
}

const SectionTitle = ({ title, handleClick, activeMegaMenu, isHomepage }: SectionTitleProps) => {
  return (
    <span
      role='button'
      onClick={(e) => {
        e.stopPropagation()
        handleClick()
      }}>
      <h5 className={activeMegaMenu ? 'category-selected' : 'category'}>{title}</h5>
      <style jsx>
        {`
          .category {
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            line-height: 22px;
            padding: 8px 0px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            white-space: nowrap;
            z-index: 100000;
            color: ${isHomepage ? 'white' : 'inherit'};
          }

          .category-selected {
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            line-height: 22px;
            padding: 8px 0px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            white-space: nowrap;
            z-index: 100000;
          }

          .category-selected:hover {
            color: ${BRAND.primaryColour};
            border-bottom: 2px solid ${BRAND.primaryColour};
            height: 22px;
            z-index: 1000;
          }

          .category:hover {
            border-bottom: 2px solid white;
            height: 22px;
            z-index: 1000;
          }
          .category-selected:active {
            color: ${BRAND.primaryColour};
            border-bottom: 2px solid ${BRAND.primaryColour};
            z-index: 10000000;
          }

          .category:active {
            border-bottom: 2px solid white;
            z-index: 10000000;
          }
        `}
      </style>
    </span>
  )
}

export default SectionTitle
